import styled from 'styled-components';
import { TextField } from '@mui/material';

export {
    Container,
    Title,
    TableContainer,
    Pagination,
    ActionButton,
    Table,
    ActionsCell,
    SearchCard as UserSearchCard,
} from '../sharedTable.styled';

export const TextFeldUserSearch = styled(TextField)`
  width: 40%;
  min-width: 220px;
`;

interface StatusProps {
    status: boolean;
}

export const StatusCell = styled.td<StatusProps>`
  color: ${({ status }) => (status ? '#34d399' : 'var(--accent-rose)')};
  font-weight: 700;
`;
